/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import DTOCreateGoalModal from './DTOCreateGoalModal';
import CreateGoalModalPresenter from './CreateGoalModalPresenter';

interface ModalInterface {
  isModalOpen: boolean;
  closeModal: any;
  trans?: any;
}

const CreateGoalModalController = ({
  isModalOpen,
  closeModal,
  trans,
}: ModalInterface) => {
  return (
    <>
      <DTOCreateGoalModal />

      <CreateGoalModalPresenter
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        trans={trans}
      />
    </>
  );
};

export default CreateGoalModalController;
